export default function renderNonBreakingHypenString(string) {
  return {__html: string.replace('-', '&#8209;')};
}
